import { styled } from "@pigment-css/react";

/**
 * Ellipsised customer-name text shared by the title pill (TitleBar) and the morph flyer
 * (MorphFlyer). Lives in ui/ because it's used by both sections — it can't belong to either.
 */
export const NameText = styled("span")({
  minWidth: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
});
